import { render, staticRenderFns } from "./MultiRoleSelect.vue?vue&type=template&id=62c8f8c4&scoped=true&"
import script from "./MultiRoleSelect.vue?vue&type=script&lang=js&"
export * from "./MultiRoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultiRoleSelect.vue?vue&type=style&index=0&id=62c8f8c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8f8c4",
  null
  
)

export default component.exports